export enum MEASURE_UNIT_LENGTH {
  m = 'm',
  cm = 'cm',
}
